import { useMemo } from 'react'

import { toast } from '@webapp/components/Notification'
import { getMessageFromError } from '@webapp/core/utils/errors/getMessageFromError'
import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { useQueryMatchedTransactions } from '../../models'

export interface IUseMatchedTransactionListPresenterParams {
  sessionId: Nullable<number>
}

/**
 * Exposes `confirmedMatches` + `clearedBalance` to the Feature Set for the
 * footer / Submit gating (BHV-036) and the Matched tab badge (BHV-030) —
 * React Query dedupes with the rendered presenter.
 */
export const useMatchedTransactionListPresenter = ({
  sessionId,
}: IUseMatchedTransactionListPresenterParams) => {
  const intl = useProcurifyIntl()

  const { matches, totalAmount, matchedCount, isLoading } =
    useQueryMatchedTransactions({
      sessionId,
      onError: (err) => {
        toast.error({
          title: intl.formatMessage(messages.errorTitle),
          children:
            getMessageFromError(err) ??
            intl.formatMessage(messages.genericErrorMessage),
        })
      },
    })

  // Only CONFIRMED matches render / count (BHV-039).
  const confirmedMatches = useMemo(
    () => matches.filter((match) => match.isConfirmed),
    [matches]
  )

  return {
    data: {
      confirmedMatches,
      clearedBalance: totalAmount,
      matchedCount,
    },
    states: {
      isLoading,
    },
  }
}
